import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "signInPage" };
const _hoisted_2 = { class: "bulletList" };
const _hoisted_3 = { class: "bulletRow" };
const _hoisted_4 = { class: "bulletIcon" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "bulletRow" };
const _hoisted_7 = { class: "bulletIcon" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "bulletRow" };
const _hoisted_10 = { class: "bulletIcon" };
const _hoisted_11 = ["src"];
const _hoisted_12 = {
    key: 0,
    class: "prefsCard"
};
const _hoisted_13 = { class: "prefsRow" };
const _hoisted_14 = { class: "prefsRow" };
const _hoisted_15 = { class: "notifActions" };
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { DotLottie } from '@lottiefiles/dotlottie-web';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGToggle from './elements/MGToggle.vue';
import { enableNotifications } from '../utils/native';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInNotificationsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, savePreferences } = useCustomer();
        /* Bundled with the app rather than fetched from LottieFiles' CDN, so it works offline */
        DotLottie.setWasmUrl(require('@lottiefiles/dotlottie-web/dotlottie-player.wasm'));
        const lottieCanvas = ref(null);
        let player = null;
        // One toggle for both balance notifications, as settings still has them separately
        const dailyBalances = computed({
            get: () => !!(state.customer?.preferences?.dailyCurrentBalanceNotifications || state.customer?.preferences?.dailyCreditBalanceNotifications),
            set: (on) => {
                const prefs = state.customer?.preferences;
                if (!prefs)
                    return;
                prefs.dailyCurrentBalanceNotifications = on;
                prefs.dailyCreditBalanceNotifications = on;
            },
        });
        function onLoad() {
            getCustomer(() => {
                if (state.customer && state.customer.preferences == null) {
                    state.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false, quizNotifications: false };
                }
            });
        }
        function enable() {
            const prefs = state.customer?.preferences;
            // Only ask the host for permission if a notification is actually wanted. The flag is a
            // latch YouPage checks, so leaving it unset lets that prompt later instead.
            if (prefs?.dailyCurrentBalanceNotifications || prefs?.dailyCreditBalanceNotifications || prefs?.quizNotifications) {
                localStorage.setItem('notificationsRequested', 'true');
                enableNotifications();
            }
            router.push({ path: '/signin/whatsapp' });
        }
        function skip() {
            router.push({ path: '/signin/whatsapp' });
        }
        function savePrefs() {
            savePreferences();
        }
        onMounted(() => {
            onLoad();
            if (lottieCanvas.value)
                player = new DotLottie({ canvas: lottieCanvas.value, src: require('@/assets/onboarding/notification-animation.lottie'), autoplay: true, loop: false });
        });
        onBeforeUnmount(() => player?.destroy());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: 0,
                    transparent: true
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("canvas", {
                        ref_key: "lottieCanvas",
                        ref: lottieCanvas,
                        class: "notifIllustration"
                    }, null, 512),
                    _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "notifTitle" }, [
                        _createTextVNode("Stay on top of"),
                        _createElementVNode("br"),
                        _createTextVNode("what matters")
                    ], -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-card.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_5)
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Voucher offers you'll actually use", -1))
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-bell.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_8)
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Reminders for renewals and bills", -1))
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-goals.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_11)
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Progress towards your goals", -1))
                        ])
                    ]),
                    (_unref(state).customer?.preferences)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", null, "Daily balances", -1)),
                                _createVNode(MGToggle, {
                                    modelValue: dailyBalances.value,
                                    "onUpdate:modelValue": [
                                        _cache[0] || (_cache[0] = ($event) => ((dailyBalances).value = $event)),
                                        savePrefs
                                    ]
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Quiz updates and reminders", -1)),
                                _createVNode(MGToggle, {
                                    modelValue: _unref(state).customer.preferences.quizNotifications,
                                    "onUpdate:modelValue": [
                                        _cache[1] || (_cache[1] = ($event) => ((_unref(state).customer.preferences.quizNotifications) = $event)),
                                        savePrefs
                                    ]
                                }, null, 8, ["modelValue"])
                            ]),
                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "prefsNote" }, "Balance notifications are available for accounts you connect. You can change these settings at any time.", -1))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                        _createVNode(MGButton, {
                            text: "Set notifications",
                            stacked: true,
                            arrow: true,
                            fullWidth: true,
                            onClick: enable
                        }),
                        _createVNode(MGButton, {
                            text: "Not now",
                            noCaps: true,
                            stacked: true,
                            fullWidth: false,
                            onClick: skip,
                            outline: false,
                            transparent: true
                        })
                    ])
                ])
            ], 64));
        };
    }
});
